import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorType } from "../../../../model/common";
import { DetailsViewProp } from "../../../../model/dashboardDetailView";

export interface GetAssessmentDetailsProp {
  loading: boolean;
  data: DetailsViewProp[] | undefined;
  status: number | null;
  error: boolean;
}

export const initialState: GetAssessmentDetailsProp = {
  loading: false,
  data: undefined,
  status: 0,
  error: false,
};

const draftReviewAssessDetailViewSlice = createSlice({
  name: "draftReviewAssessDetailView",
  initialState,
  reducers: {
    reset: () => initialState,
    draftReviewAssessDetailViewRequest(
      state: GetAssessmentDetailsProp,
      action: PayloadAction<string>,
    ) {
      state.loading = true;
    },
    draftReviewAssessDetailViewSuccess(
      state: GetAssessmentDetailsProp,
      action: PayloadAction<{
        data: DetailsViewProp[];
        status: number;
      }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    draftReviewAssessDetailViewFailure(
      state: GetAssessmentDetailsProp,
      action: PayloadAction<{ error: ErrorType }>,
    ) {
      state.loading = false;
      state.status = action.payload.error.response.status;
      state.error = true;
    },
  },
});

export const draftReviewAssessDetailViewAction =
  draftReviewAssessDetailViewSlice.actions;
export const getDraftReviewAssessDetailReducer =
  draftReviewAssessDetailViewSlice.reducer;

export default getDraftReviewAssessDetailReducer;
